module.exports = __webpack_public_path__ + "static/media/abyss.bb8c4c70.jpg";